import Button from '@/common/components/Button'
import Modal from '@/common/components/Modal'
import { ModalMessageSimple } from '@/common/components/ModalMessageSimple'
import { FormTransformers } from '@/common/utils/formTransformers'
import { useDeleteMaintenanceSolicitation } from '@/features/maintenanceSolicitations/hooks/useDeleteMaintenanceSolicitation'
import { useQueryClient } from '@tanstack/react-query'
import { useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

export const ModalDeleteMaintenanceSolicitation = () => {
  const { id } = useParams()
  const navigate = useNavigate()
  const queryClient = useQueryClient()

  const [isOpen, setIsOpen] = useState(false)
  const [messages, setMessages] = useState<string[] | boolean>(false)

  const onSuccess = () => {
    queryClient.invalidateQueries({ queryKey: ['maintenanceSolicitations'] })
    navigate('/maintenance-solicitations')
  }

  const { mutate: deleteCompanyBranchAdditionalDocument, isPending: deleteCompanyBranchAdditionalDocumentIsPending } =
    useDeleteMaintenanceSolicitation({
      id: id || '',
      onSuccess,
      onError: FormTransformers.errorsTransformer({ setMessages }),
    })

  return (
    <>
      <Modal
        isOpen={isOpen}
        setIsOpen={(value) => setIsOpen(value)}
        Trigger={
          <Button
            name="delete_maintenance_solicitation"
            variant="outline-error"
            operationKlassToCheckPermission="Client::Maintenance::Solicitations::Destroy"
          >
            Deletar
          </Button>
        }
        triggerAsChild
        title="Confirmar Exclusão"
        subtitle="Tem certeza que deseja excluir esta solicitação de manutenção? Esta ação não pode ser desfeita."
        titleClass="text-2xl"
        subtitleClassName="mt-1 text-sm"
        showClose={false}
        useCancellableFooter
        disabled={deleteCompanyBranchAdditionalDocumentIsPending}
        confirmButtonIsLoading={deleteCompanyBranchAdditionalDocumentIsPending}
        onConfirm={() => deleteCompanyBranchAdditionalDocument()}
      />

      <ModalMessageSimple messages={messages} setMessages={setMessages} isError />
    </>
  )
}
